"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHR = exports.XhrTransport = void 0;
var transport_1 = require("./transport");
var debug = console.debug;
function XhrTransport() {
    return function (opts) { return new XHR(opts); };
}
exports.XhrTransport = XhrTransport;
var XHR = (function () {
    function XHR(transportOptions) {
        this.index = 0;
        this.options = transportOptions;
        this.withCredentials = transportOptions.withCredentials;
    }
    XHR.prototype.onStateChange = function () {
        this.options.debug && debug('XHR.onStateChange', this.xhr.readyState);
        if (this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
            this.options.onHeaders((0, transport_1.http1ResToMeta)(this.xhr.getAllResponseHeaders()), this.xhr.status);
        }
        else if (this.xhr.readyState === XMLHttpRequest.DONE) {
            this.options.onChunk(this.xhr.response);
            this.options.onEnd();
        }
    };
    XHR.prototype.sendMessage = function (msgBytes, metadata) {
        var _this = this;
        var xhr = new XMLHttpRequest();
        this.xhr = xhr;
        xhr.open('POST', this.options.url);
        this.xhr.responseType = 'arraybuffer';
        Object.keys(metadata).forEach(function (k) {
            xhr.setRequestHeader(k, metadata[k]);
        });
        xhr.withCredentials = this.withCredentials;
        xhr.addEventListener('readystatechange', this.onStateChange.bind(this));
        xhr.addEventListener('error', function (err) {
            _this.options.debug && debug('XHR.error', err);
            _this.options.onEnd(new Error(JSON.stringify(err.target)));
        });
        xhr.send(msgBytes);
    };
    XHR.prototype.cancel = function () {
        this.options.debug && debug('XHR.abort');
        this.xhr.abort();
    };
    return XHR;
}());
exports.XHR = XHR;
